
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/give/sitemap",
      function () {
        return require("private-next-pages/give/sitemap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/give/sitemap"])
      });
    }
  